import React, {useState} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import {AlertDialog} from "../Common";

const useStyles = makeStyles(theme => ({
    button: {
        marginLeft: "auto",
        marginRight: 0,
    },
}));

const OptionButton = () => {
    const classes = useStyles();

    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleMenu = event => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const [reportOpen, reportSetOpen] = useState(false);
    const [blockOpen, blockSetOpen] = useState(false);

    const handleReportOpen = () => {
        reportSetOpen(true);
    };

    const handleReportClose = () => {
        reportSetOpen(false);
    };

    const handleBlockOpen = () => {
        blockSetOpen(true);
    };

    const handleBlockClose = () => {
        blockSetOpen(false);
    };

    return (
        <>
            <IconButton className={classes.button} aria-label="options" onClick={handleMenu}>
                <MoreHorizIcon />
            </IconButton>
            <Menu
                id="menu-appbar"
                anchorEl={anchorEl}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                keepMounted
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                open={open}
                onClose={handleClose}
            >
                <MenuItem onClick={() => {handleReportOpen()}}>不適切な投稿として報告する</MenuItem>
                <MenuItem onClick={() => {handleBlockOpen()}}>このユーザーをブロック</MenuItem>
            </Menu>
            <AlertDialog type={"report"} open={reportOpen} handleClose={handleReportClose} menuClose={handleClose}
                         title={"この投稿を不適切として報告しますか？"}
                         description={"この操作はやり直しができません。"} />
            <AlertDialog type={"block"} open={blockOpen} handleClose={handleBlockClose} menuClose={handleClose}
                         title={"本当にこのユーザーをブロックしますか？"}
                         description={"この操作はやり直しができません。ブロック後、このユーザーの投稿は表示されなくなります。"}/>
        </>
    );
};

export default OptionButton;